import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import { GetDeliveryCountriesErrorResponse, GetDeliveryCountriesSuccessResponse } from './getDeliveryCountries.types'

export const getDeliveryCountriesApi = async (): Promise<GetDeliveryCountriesSuccessResponse> => {
  const response = await configureRequest({
    url: urls.offers.getDeliveryCountries,
    method: 'GET',
    headers: {
      'X-User-Role': UserRole.shopper
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetDeliveryCountriesSuccessResponse
  } else {
    throw response as GetDeliveryCountriesErrorResponse
  }
}

export default getDeliveryCountriesApi
